import React from "react";
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { store } from "../../redux/store";
import { connect } from "react-redux";
import './claim.css';
import history from "../../auth/history";
import HeadeCommon from "../HeaderComponent/HeadeCommon";
import Menu from "../MenuComponent/Menu";
import FooterComponet from "../FooterComponent/FooterComponet";
import Select from 'react-select';
import moment from "moment";
import { Link } from "react-router-dom";
const httpClient = axios.create();

class ClaimDeatails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
        }
    }



    componentDidMount() {


    }
    componentWillUnmount() {
    }



    render() {

        return (
            <div>
                <HeadeCommon />
                <Menu />
                <div class="mid">
                    <div class="container-fluid">
                        <div class="head">
                            <br />
                            <h3>Claim Details</h3>
                            <Link to='/claim-upload'>
                            <button class="btn" type="button">Back</button>
                            </Link>
              
                        </div>

                        <div class="loaddtl">
                            <h4>Thank you, details have been submited successfully!</h4>

                            <div class="bankcard">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-striped">
                                        <tbody><tr>
                                            <td width="160">TA Load Amount:</td>
                                            <td>₹ {(this.props.claimResp.amount != '' &&
                                                this.props.claimResp.amount != null &&
                                                this.props.claimResp.amount != undefined) ?
                                                parseFloat(this.props.claimResp.amount).toFixed(2) : 'NA'
                                            }</td>
                                        </tr>
                                            <tr>
                                                <td>Bank Name:</td>
                                                <td>{(this.props.claimResp.bank != '' &&
                                                    this.props.claimResp.bank != null &&
                                                    this.props.claimResp.bank != undefined) ?
                                                    this.props.claimResp.bank : 'NA'
                                                }</td>
                                            </tr>
                                            <tr>
                                                <td>Transaction ID:</td>
                                                <td>  {(this.props.claimResp.utr != '' &&
                                                    this.props.claimResp.utr != null &&
                                                    this.props.claimResp.utr != undefined) ?
                                                    this.props.claimResp.utr : 'NA'
                                                }</td>
                                            </tr>
                                            <tr>
                                                <td>Date:</td>
                                                <td>{(this.props.claimResp.txnDate != '' &&
                                                    this.props.claimResp.txnDate != null &&
                                                    this.props.claimResp.txnDate != undefined) ?
                                                    moment(this.props.claimResp.txnDate).format('DD-MM-YYYY') : 'NA'
                                                }</td>
                                            </tr>
                                            <tr>
                                                <td>Transaction Mode:</td>
                                                <td>{(this.props.claimResp.txnMode != '' &&
                                                    this.props.claimResp.txnMode != null &&
                                                    this.props.claimResp.txnMode != undefined) ?
                                                    this.props.claimResp.txnMode : 'NA'
                                                }</td>
                                            </tr>
                                            <tr>
                                                <td>Request ID:</td>
                                                <td>{(this.props.claimResp.refId != '' &&
                                                    this.props.claimResp.refId != null &&
                                                    this.props.claimResp.refId != undefined) ?
                                                    this.props.claimResp.refId : 'NA'
                                                }</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                {/* <div class="txn-btn">
                                    <button type="button" class="print">Print</button>
                                    <button type="button" class="help"></button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <FooterComponet />
            </div>
        );
    }
}


const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    miscReduce: { phone, agentInfo, token, loginTime, partner, logoName, claimResp }
    , authReduce: { callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, phone, agentInfo, token, loginTime, partner, logoName, claimResp,
    callBackUrl
});




export default connect(mapStateToProps, null)(ClaimDeatails);
